// extracted by mini-css-extract-plugin
module.exports =  {"text-align-center":"_9330de7794--text-align-center--wS6Cz","text-align-right":"_9330de7794--text-align-right--EMFbI"};